var $ec93d97ef3e4f3e7$exports = {};
$ec93d97ef3e4f3e7$exports = {
    "close": `Aizv\u{113}rt`,
    "notifications": (args, formatter)=>`${formatter.plural(args.count, {
            one: ()=>`${formatter.number(args.count)} pazi\u{146}ojums`,
            other: ()=>`${formatter.number(args.count)} pazi\u{146}ojumi`
        })}.`
};


export {$ec93d97ef3e4f3e7$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
